import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class WorkerCategory extends BaseApi {
	getRoleBaseMenuList(RoleId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetRoleBaseMenuList`, { RoleId });
	}
}
export const apiProvider = new WorkerCategory(DMS_MODULE, NAME);
